export default __webpack_public_path__ + "static/media/agendamento.238194ae.svg";